import { useMutation } from '@apollo/client';
import { gql } from '../graphql/generated/gql';
import localLogout, { ignoreNextLocalLogout } from './localLogout';

const LOGOUT_MUTATION = gql(`
  mutation logout {
    logout
  }
`);

const useLogout = (options: Parameters<typeof localLogout>[0] = {}) => {
  const [logoutMutate] = useMutation(LOGOUT_MUTATION);

  const handleLogout = () => {
    if (options.preventRedirect) {
      ignoreNextLocalLogout();
    }
    logoutMutate().finally(() => {
      localLogout(options);
    });
  };

  return handleLogout;
};

export default useLogout;
